// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectShipmentsInStore,
  selectShipmentsPageLoading,
  selectShipmentsShowInitWaitingMessage,
} from '../_selectors/shipment.selectors';

export class ShipmentsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectShipmentsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectShipmentsShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectShipmentsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
        //console.log(response.items);
      });
  }
}
